// Add your custom JS here.
//import '../../inc/swiper-bundle.min.js';
import '../../blocks/accordion/accordion.js';
import '../../blocks/media-only/media-only.js';
import '../../blocks/scrolling-timeline/scrolling-timeline.js';
import '../../blocks/search-page-type/search-page-type.js';
import '../../blocks/stat-columns/stat-columns.js';
import '../../blocks/stat-columns-minimal/stat-columns-minimal.js';
import '../../blocks/tabbed-content-horizontal-tabs/tabbed-content-horizontal-tabs.js';
import '../../blocks/tabbed-content-vertical-tabs/tabbed-content-vertical-tabs.js';
import '../../blocks/testimonials/testimonials.js';
import '../../blocks/services-slider/services-slider.js';
import '../../blocks/hero-header/hero-header.js';
import '../../blocks/stat-counter-tabbed-view/stat-counter-tabbed-view.js';
import '../../blocks/locations/locations.js';
import '../../blocks/text-with-media/text-with-media.js';
import '../../blocks/sliding-cards/sliding-cards.js';
import '../../blocks/trustmarks/trustmarks.js';

document.addEventListener('DOMContentLoaded', function() {
    const header = document.getElementById('site-header');
    
    // Desktop menu controls
    const parentMenu = header.querySelector('#menu-header-menu');
    const parentMenuItems = parentMenu.querySelectorAll('li.menu-item-object-page');

    parentMenuItems.forEach((menuItem) => {
        menuItem.addEventListener('mouseover', function() {
            header.querySelectorAll('div.dropped-down').forEach((subMenu) => {
                subMenu.classList.remove('active');
            });
            const subMenu = menuItem.querySelector('div.dropped-down');
            subMenu.classList.add('active');
            header.querySelector('.header-layout').classList.add('dropdown-active');
        })
        menuItem.addEventListener('mouseleave', function() {
            header.querySelectorAll('div.dropped-down').forEach((subMenu) => {
                subMenu.classList.remove('active');
                header.querySelector('.header-layout').classList.remove('dropdown-active');
            });
        })
    });

    // Mobile menu Controls
    const mobileMenuToggle = header.querySelector('.mobile-nav-toggle');
    const mobileMenu = header.querySelector('.mobile-nav');

    mobileMenuToggle.addEventListener('click', function() {
        mobileMenuToggle.classList.toggle('clicked');
        mobileMenu.classList.toggle('active');
        header.querySelector('.header-layout').classList.toggle('dropdown-active');
    })
});

// Trustmarks slider in the footer
const trustmarksSwiper = new Swiper('.footer-trustmarks .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    navigation: {
        nextEl: '.trustmarks-button-next',
    },
});

// Manage tabs that turn inot dropdowns on mobile
const dropdownMobile = document.querySelectorAll('.dropdown-on-mobile');
dropdownMobile.forEach((dropdown) => {
    const dropdownMobileHeader = dropdown.querySelector('.dropdown-mobile-header');
    const dropdownMobileTarget = dropdown.querySelector('.mobile-dropdown-target');

    dropdownMobileHeader.addEventListener('click', function() {
        dropdownMobileHeader.classList.toggle('clicked');
        dropdownMobileTarget.classList.toggle('clicked');
    });

    dropdownMobileTarget.querySelectorAll('div').forEach((target) => {
        target.addEventListener('click', function() {
            dropdownMobileHeader.classList.toggle('clicked');
            dropdownMobileTarget.classList.toggle('clicked');
        });
    });
});

// Make header fixed position and have it appear/reappear based on scroll
let prevScrollPos = window.scrollY;
let headerBar = document.querySelector('.header-layout');

window.addEventListener('scroll', function() {
    const currentScrollPos = window.scrollY;

    if(currentScrollPos > 100) {
        if(prevScrollPos < currentScrollPos) {
            headerBar.classList.add('fade-off');
        } else {
            headerBar.classList.remove('fade-off');
        }
    }

    prevScrollPos = currentScrollPos;
});
